export default {
  add_items: 'Dodaj produkty',
  remove_items: 'Usuń produkty',
  place_order: 'Złóż zamówienie',
  pay_now: 'Zapłać teraz · {{amount}}',
  go_to_menu: 'Przejdź do menu',
  secure_checkout: 'Bezpieczna płatność...',

  error_messages: {
    payment_unsuccessful: {
      title: 'Płatność nieudana',
      description: 'Sprawdź dane płatności i spróbuj ponownie.',
    },
    internal_error: {
      title: 'Zamówienie nieudane 😔',
      description:
        'Niestety wystąpił nieoczekiwany problem z Twoim zamówieniem — nasz zespół techniczny już nad tym pracuje 🛠️.',
    },
    order_blocked: {
      title: 'Zamówienie zablokowane',
      description:
        'Wykryliśmy podejrzaną aktywność na Twoim koncie i zablokowaliśmy nowe zamówienia do {{datetime}}. Skontaktuj się z pomocą pod adresem {{supportEmail}}, aby uzyskać szczegóły.',
      description_no_datetime:
        'Wykryliśmy podejrzaną aktywność na Twoim koncie i zablokowaliśmy nowe zamówienia. Skontaktuj się z pomocą pod adresem {{supportEmail}}, aby uzyskać szczegóły.',
    },
  },

  toasts: {
    input_errors_found: 'Wystąpiły problemy z danymi zamówienia',
    select_payment_method: 'Wybierz metodę płatności, aby złożyć zamówienie.',
  },
};
